"use client";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { DatePickerRangeFilter } from "@/components/ui/dateRangeFilter";
import {
  useCategoryAspirationOptions,
  useDapilOptions,
  useFraksiOptions,
  useKomisiOptions,
  usePeriodOptions,
  useToolsOptions,
} from "@/hooks/useSelect";
import { ListFilter, X } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import SelectSearchFilter from "./selectSearch";

interface TriggerAllFilterProps {
  category?: boolean;
  electoralDistrict?: boolean;
  rangeDate?: boolean;
  fraction?: boolean;
  commission?: boolean;
  akd?: boolean;
  period?: boolean;
}
const TriggerAllFilter = ({
  category,
  electoralDistrict,
  rangeDate,
  fraction,
  commission,
  period,
  akd,
}: TriggerAllFilterProps) => {
  const pathname = usePathname();
  const route = useRouter();
  const handleReset = () => {
    route.push(pathname);
  };

  const fractionOption = useFraksiOptions();
  const categoryOptions = useCategoryAspirationOptions();
  const electoralDistrictOptions = useDapilOptions();
  const commissionOptions = useKomisiOptions();
  const akdOptions = useToolsOptions();
  const periodOptions = usePeriodOptions();
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button className="rounded-full h-[2.6rem] text-white bg-primary-700">
          <ListFilter /> <span className="md:block hidden">Filter</span>
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex justify-between items-center">
            <AlertDialogTitle className="text-center">Filter</AlertDialogTitle>
            <AlertDialogCancel className="rounded-full p-2 m-0 h-8 border-none shadow-none">
              <X />
            </AlertDialogCancel>
          </div>
        </AlertDialogHeader>
        <AlertDialogDescription />
        <>
          {rangeDate && (
            <DatePickerRangeFilter
              placeholder="DD-MM-YYYY - DD-MM-YYYY"
              className="w-full"
            />
          )}
          {category && (
            <SelectSearchFilter
              items={categoryOptions || []}
              label="Kategori Usulan"
              placeholder="Pilih Kategori Usulan"
              paramKey="category"
              all
            />
          )}
          {fraction && (
            <SelectSearchFilter
              items={fractionOption || []}
              label="Partai"
              placeholder="Pilih Partai"
              paramKey="fraksi"
              all
            />
          )}
          {electoralDistrict && (
            <SelectSearchFilter
              items={electoralDistrictOptions || []}
              label="Dapil"
              placeholder="Pilih Dapil"
              paramKey="dapil"
              all
            />
          )}
          {/* {commission && (
            <SelectSearchFilter
              items={commissionOptions || []}
              label="Komisi"
              placeholder="Pilih Komis"
              paramKey="komisiId"
              all
            />
          )} */}
          {akd && (
            <SelectSearchFilter
              items={akdOptions || []}
              label="AKD"
              placeholder="Pilih AKD"
              paramKey="akd"
              all
            />
          )}
          {period && (
            <SelectSearchFilter
              items={periodOptions || []}
              label="Periode"
              placeholder="Pilih Periode"
              paramKey="periodeId"
              all
            />
          )}
        </>
        <AlertDialogFooter>
          <div className="flex justify-end gap-2">
            <AlertDialogAction
              className="rounded-full bg-transparent text-primary-700 hover:bg-slate-200"
              onClick={handleReset}
            >
              Reset
            </AlertDialogAction>
            <AlertDialogCancel className="rounded-full bg-primary-700 text-white hover:bg-primary-700/90 hover:text-white mt-0">
              Terapkan
            </AlertDialogCancel>
          </div>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default TriggerAllFilter;
